import { render, staticRenderFns } from "./inputRecord.vue?vue&type=template&id=2dd3e141&scoped=true"
import script from "./inputRecord.vue?vue&type=script&lang=js"
export * from "./inputRecord.vue?vue&type=script&lang=js"
import style0 from "./inputRecord.vue?vue&type=style&index=0&id=2dd3e141&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd3e141",
  null
  
)

export default component.exports